import type { RootState } from '../../store';

export const selectCountryCode = (state: RootState): string | undefined => {
    return state.user.data?.country?.code;
};
